<cdk-virtual-scroll-viewport itemSize="32"
    class="my-5 overflow-y-auto h-full overflow-x-hidden w-full pr-[15px] box-content activity-feed-scroll scrollbar-stable"
    (scrolledIndexChange)="onScrolledIndexChange($event)">
    <h2 title *ngIf="chatFeed.length > 0" class="text-lg font-semibold text-app-sidenav-main-text ml-[15px] mb-2" i18n>
        Recente chats
    </h2>
    <div *cdkVirtualFor="let item of chatFeed;" cl ass="w-full flex flex-col mb-1">
        <!-- Item title + ... button -->
        <a class="flex flex-row justify-between items-center p-4 rounded-lg max-h-4 cursor-pointer hover:bg-app-sidenav-main-text-background-hover"
            (mouseenter)="onMouseEnter(item)" (mouseleave)="onMouseLeave(item)"
            [ngClass]="{'bg-app-sidenav-main-text-background-hover': chatFeedService.selectedChatId$.value === item.id || editingItemId === item.id || item.hovered}"
            [routerLink]="['chat', item.id]">
            <div class="text-ellipsis whitespace-nowrap overflow-hidden flex gap-2 items-center w-full">
                <!-- Input that appears when editing the item title -->
                <input *ngIf="editingItemId === item.id" #itemTitleInput [attr.item-id]="item.id"
                    class="text-app-sidenav-main-text bg-transparent items-center appearance-none outline-none w-full"
                    (keydown.enter)="itemTitleInput.blur()" (focusout)="exitTitleEdit($event, item)" type="text"
                    [value]="item.title" />
                <!-- Current item title-->
                <p *ngIf="editingItemId !== item.id" title="{{ item.title }}"
                    class="text-app-sidenav-main-text truncate">{{item.title}}</p>
            </div>
            <!-- ... button for edit menu -->
            <div [matMenuTriggerFor]="menu" #trigger="matMenuTrigger"
                (click)="$event.stopPropagation(); $event.preventDefault()"
                class="hover:bg-app-sidenav-main-text-background-hover rounded-md cursor-pointer flex items-center ml-auto">
                <mat-icon *ngIf="item.hovered || trigger.menuOpen || !breakpoint.lg.value || editingItemId === item.id"
                    svgIcon="ellipsis" class="text-app-sidenav-main-text "></mat-icon>
            </div>
        </a>

        <!--  Item edit menu -->
        <mat-menu #menu yPosition="below">
            <button mat-menu-item (click)="enterTitleEdit(item)" i18n>
                <mat-icon svgIcon="pencil"></mat-icon>
                <span>Naam wijzigen</span>
            </button>
            <button mat-menu-item class="menu-delete-button" (click)="deleteItem(item)" i18n>
                <mat-icon svgIcon="trash-2"></mat-icon>
                <span>Verwijderen</span>
            </button>
        </mat-menu>
    </div>
</cdk-virtual-scroll-viewport>

<dynamic-dialog #deleteChatDialog>
    <h1 title i18n>Chat verwijderen</h1>
    <p class="text-center" i18n>
        Weet je zeker dat je deze chat wilt verwijderen? Je kunt deze actie niet ongedaan maken.
    </p>
</dynamic-dialog>